import Client from './client';

export default class SearchProviderExports extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  post(organization, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/search_provider_export`, {
      ...options,
       method: 'POST',
    });
  }

  postExperienceByExperienceKey(organization, experienceKey, options = {}) {
    return this.makeRequest(`${this.host}/${organization}/search_provider_export/experience/${experienceKey}`, {
      ...options,
       method: 'POST',
    });
  }

}
